import { render } from "./AddonAttachments.vue?vue&type=template&id=93daac66&scoped=true"
import script from "./AddonAttachments.vue?vue&type=script&lang=js"
export * from "./AddonAttachments.vue?vue&type=script&lang=js"

import "./AddonAttachments.vue?vue&type=style&index=0&id=93daac66&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93daac66"]])

export default __exports__